import React from "react";
import FatherLayout from "../../components/Parents/FatherLayout";
import { CircularProgress, CircularProgressLabel } from "@chakra-ui/react";
import HomeRightStats from "../../components/Parents/Home/HomeRightStats";
import EmotionsRecognition from "../../components/Parents/Home/Graphs/EmotionsRecognition";
import UseFrequency from "../../components/Parents/Home/Graphs/UseFrequency";

function DashboardHome() {
    return (
        <FatherLayout title="Home" rightParentContent={<HomeRightStats />} showWelcomeBanner={true}>
            <div className="flex flex-col">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
                    <div className="bg-[#AEECE2] rounded-2xl flex flex-col p-5" style={{ boxShadow: "0px 10px 30px 0px #369FFF66"}}>
                        <div className="w-full text-lg font-bold">Correct Answers</div>
                        <div className="w-full text-xs font-semibold">50 correct answers in total</div>
                        <div className="mt-4">
                            <CircularProgress value={25} capIsRound color='#fff' trackColor='#A6E3D9' thickness='12px' >
                                <CircularProgressLabel><div className="text-sm font-medium m-2">25%</div></CircularProgressLabel>
                            </CircularProgress>
                        </div>
                    </div>
                    <div className="bg-[#FFEB99] rounded-2xl flex flex-col p-5" style={{ boxShadow: "0px 10px 30px 0px #FF993A66"}}>
                        <div className="w-full text-lg font-bold">Levels Completed</div>
                        <div className="w-full text-xs font-semibold">10 levels Completed</div>
                        <div className="mt-4">
                            <CircularProgress value={5} capIsRound color='#fff' trackColor='#FFE081' thickness='12px' >
                                <CircularProgressLabel><div className="text-sm font-medium m-2">5%</div></CircularProgressLabel>
                            </CircularProgress>
                        </div>
                    </div>
                </div>
                <div className="my-6">
                    <div className="w-full font-bold text-xl my-2"> Emotions Recognition </div>
                    <EmotionsRecognition />
                </div>
                <div className="mt-6">
                    <div className="w-full font-bold text-xl my-2"> Use Frequency </div>
                    <UseFrequency />
                </div>
            </div>
        </FatherLayout>
    );
}

export default DashboardHome;
